import {slideDown, slideUp, fadeIn, fadeOut} from "../helpers/animation";

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-cart-item').forEach((item) => {
		const counterEl = item.querySelector('.js-count-input');
		const counterDecreaseEl = item.querySelector('.js-count-decrease');
		const counterIncreaseEl = item.querySelector('.js-count-increase');

		counterEl.addEventListener('change', () => {
			updateCartData(counterEl)
		});

		counterDecreaseEl.addEventListener('click', () => {
			setTimeout(() => {
				updateCartData(counterEl);
			}, 0)
		});

		counterIncreaseEl.addEventListener('click', () => {
			setTimeout(() => {
				updateCartData(counterEl);
			}, 0)
		});
	})
});

const updateCartData = (counterEl) => {
	let basketId = $(counterEl).data('id');
	let data = {
		"count": $(counterEl).val()
	};
	$.ajax({
		url: `/api/cart-count/${basketId}/`,
		dataType: "html",
		'method': 'POST',
		data: data,
		success: function (data) {
			let responce = JSON.parse(data);
			if (responce.data.success) {
				updateSum(basketId, responce.data.count, responce.data.product_sum, responce.data.cart_sum);
			}
		}
	});
}

// подсчет суммы итого
export const updateSum = (basketId, iCount, strProductSum, strCartSum) => {
	document.querySelector('.js-cart-sum').innerText = strCartSum;
	$('.js-cart-quantity[data-id="' + basketId + '"]').text(iCount);
	$('.js-count-input[data-id="' + basketId + '"]').val(iCount).trigger('update');
	$('.js-cart-total[data-id="' + basketId + '"]').text(strProductSum);

}
